import { render, staticRenderFns } from "./copy_yesterday_button.vue?vue&type=template&id=355814f3&scoped=true&lang=html&"
import script from "./copy_yesterday_button.vue?vue&type=script&lang=js&"
export * from "./copy_yesterday_button.vue?vue&type=script&lang=js&"
import style0 from "./copy_yesterday_button.vue?vue&type=style&index=0&id=355814f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355814f3",
  null
  
)

export default component.exports